import React, { useState } from 'react';
import PropTypes from 'prop-types';

import BankAccountPresenter from '../../../../../presenters/BankAccountPresenter';
import { updateBankAccountDuplicationState } from '../../../../../mutations';

import BankAccountCell from './components/BankAccountCell';
import StateChangeModal from './components/StateChangeModal';

const BankAccountsList = (props) => {
  const { bankAccounts, relay, searchParams } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [bankAccountParams, setbankAccountParams] = useState({});
  const [errors, setErrors] = useState(null);

  const handleDialogOpen = (bankAccount) => {
    setbankAccountParams(bankAccount);
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => setIsDialogOpen(false);

  const handleStateChange = ({ target }) => {
    const { id, value } = target;
    setbankAccountParams({ ...bankAccountParams, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { id, duplicationState, originalBankAccountId } = bankAccountParams;
    const updateParams = {
      ...searchParams,
      id,
      duplicationState,
      originalBankAccountId,
    };

    return updateBankAccountDuplicationState(relay.environment, updateParams, {
      onCompleted: handleSubmitSuccess,
    });
  };

  const handleSubmitSuccess = ({ updateBankAccountDuplicationState }) => {
    const { errors, errorMessage } = updateBankAccountDuplicationState;
    if (errors) return setErrors(errors);
    if (errorMessage) return setErrors(errorMessage);

    handleDialogClose();
  };

  return (
    <div className="bank-accounts">
      <div className="header">
        <div className="form-header">
          <h3>Bank Accounts list</h3>
          <div className="form-header-actions"></div>
        </div>
      </div>
      <StateChangeModal
        bankAccountParams={bankAccountParams}
        onStateChange={handleStateChange}
        onDialogClose={handleDialogClose}
        isDialogOpen={isDialogOpen}
        onSubmit={handleSubmit}
        errors={errors}
      />
      <table className="tables bank-account-table">
        <thead>
          <tr>
            <th>Plaid Bank Account Id</th>
            <th>Mask</th>
            <th>Name</th>
            <th>Institution Name</th>
            <th>Official Name</th>
            <th>Account Type / Subtype</th>
            <th>Duplication State</th>
            <th>Original Bank Account</th>
            <th>Actions</th>
          </tr>
        </thead>
        {bankAccounts.map((bankAccount) => (
          <BankAccountCell
            key={BankAccountPresenter.id(bankAccount)}
            bankAccount={bankAccount}
            onEditDialogOpen={() => handleDialogOpen(bankAccount)}
          />
        ))}
      </table>
    </div>
  );
};

export default BankAccountsList;

BankAccountsList.propTypes = {
  searchParams: PropTypes.shape().isRequired,
  bankAccounts: PropTypes.arrayOf(BankAccountPresenter.shape()).isRequired,
  relay: PropTypes.shape().isRequired,
};
